import { render, staticRenderFns } from "./HeroHome.vue?vue&type=template&id=2c7c42de&scoped=true&"
import script from "./HeroHome.vue?vue&type=script&lang=js&"
export * from "./HeroHome.vue?vue&type=script&lang=js&"
import style0 from "./HeroHome.vue?vue&type=style&index=0&id=2c7c42de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7c42de",
  null
  
)

export default component.exports